module.exports = __webpack_public_path__ + "img/token.0a1b663b.gif";